<template>
	<modal
		:modal-id="modalId"
		:title="modalTitle"
		:preloader="preloader"
		@submit="submit"
		@close-modal="closeModal"
	>
		<template slot="body">
			<app-overlay-loader v-if="preloader" />
			<form
				class="mb-0"
				:class="{ 'loading-opacity': preloader }"
				ref="form"
				:data-url="`transaction/invoice-fee`"
			>
				<!-- Invoice Item -->
				<div class="form-group row align-items-center">
					<label for="input_invoice_item_id" class="col-sm-3 mb-0">
						Invoice Item
					</label>
					<app-input
						id="input_invoice_item_id"
						class="col-sm-9"
						type="search-select"
						:list="invoiceItemIdLists"
						v-model="inputs.invoice_item_id"
						placeholder="Invoice Item"
						:required="true"
					/>
				</div>
				<!-- Product Name -->
				<div class="form-group row align-items-center">
					<label for="input_product_id" class="col-sm-3 mb-0">
						Product Name
					</label>
					<app-input
						id="input_product_id"
						class="col-sm-9"
						type="search-select"
						:list="productIdLists"
						v-model="inputs.product_id"
						placeholder="Product Name"
						:required="true"
					/>
				</div>
				<!-- UOM -->
				<div class="form-group row align-items-center">
					<label for="inputs_uom_id" class="col-sm-3 mb-0"> UOM </label>
					<app-input
						id="inputs_uom_id"
						class="col-sm-9"
						type="search-select"
						:list="uomIdLists"
						v-model="inputs.uom_id"
						placeholder="UOM"
						:required="true"
					/>
				</div>
				<!-- Quantity -->
				<div class="form-group row align-items-center">
					<label for="inputs_qty" class="col-sm-3 mb-0">
						Quantity
					</label>
					<app-input
						id="inputs_qty"
						class="col-sm-9"
						type="number"
						v-model="inputs.qty"
						placeholder="Quantity"
						:required="true"
					/>
				</div>
				<!-- Unit Price -->
				<div class="form-group row align-items-center">
					<label for="inputs_price" class="col-sm-3 mb-0">
						Unit Price
					</label>
					<app-input
						id="inputs_price"
						class="col-sm-9"
						type="number"
						v-model="inputs.price"
						placeholder="Unit Price"
						:required="true"
					/>
				</div>
				<!-- Charges -->
				<div class="form-group row align-items-center">
					<label for="inputs_charge_id" class="col-sm-3 mb-0">
						Charges
					</label>
					<app-input
						id="inputs_charge_id"
						class="col-sm-9"
						type="search-select"
						:list="chargeIdLists"
						v-model="inputs.inputs_charge_id"
						placeholder="Charges"
						:required="true"
					/>
				</div>
				<!-- Credits -->
				<div class="form-group row align-items-center">
					<label for="inputs_credit_id" class="col-sm-3 mb-0">
						Credits
					</label>
					<app-input
						id="inputs_credit_id"
						class="col-sm-9"
						type="search-select"
						:list="creditIdLists"
						v-model="inputs.credit_id"
						placeholder="Credits"
						:required="true"
					/>
				</div>
				<!-- Balance -->
				<div class="form-group row align-items-center">
					<label for="inputs_amount" class="col-sm-3 mb-0">
						Balance
					</label>
					<app-input
						id="inputs_amount"
						class="col-sm-9"
						type="number"
						v-model="inputs.amount"
						placeholder="Balance"
						:required="true"
					/>
				</div>
			</form>
		</template>
	</modal>
</template>

<script>
import { FormMixin } from "../../../../../../../../core/mixins/form/FormMixin.js";
import { ModalMixin } from "../../../../../../../Mixins/ModalMixin";

export default {
	name: "LogTableForm",
	mixins: [FormMixin, ModalMixin],
	props: {
		tableId: String,
		formId: String,
		invoiceRequestId: {
			type: Number,
		},
	},
	data() {
		return {
			preloader: false,
			inputs: {
				invoice_id: this.invoiceRequestId,
				invoice_item_id: "",
				product_id: "",
				uom_id: "",
				qty: "",
				price: "",
				charge_id: "",
				credit_id: "",
				amount: "",
			},
			phone: "",
			modalId: this.formId,
			modalTitle: this.$t("add"),
			invoiceItemIdLists: [],
			productIdLists: [],
			uomIdLists: [],
			chargeIdLists: [],
			creditIdLists: [],
		};
	},
	created() {
		if (this.selectedUrl) {
			this.modalTitle = this.$t("edit");
			this.preloader = true;
		}

		this.fetchData();
	},
	methods: {
		async fetchData() {

		},
		submit() {
			this.save(this.inputs);
		},
		afterSuccess(response) {
			this.$toastr.s(response.data.message);
			this.$hub.$emit("reload-" + this.tableId);
		},

		afterSuccessFromGetEditData(response) {
			if (response.data.phone) this.phone = response.data.phone;
			this.inputs = response.data;
			this.preloader = false;
		},
	},
	watch: {
		// "inputs.product_id": function (val) {
		// 	if (val == "charges") {
		// 		this.productCategoryLists = [
		// 			{ id: "course_fee", value: "Course Fee" },
		// 			{ id: "registration_fee", value: "Registration Fee" },
		// 			{ id: "placement_fee", value: "Placement Fee" },
		// 			{ id: "admission_fee", value: "Admission Fee" },
		// 			{
		// 				id: "clc_app_learning_support",
		// 				value: "CLC App Learning Support",
		// 			},
		// 			{ id: "outstanding_balance", value: "Outstanding Balance" },
		// 			{ id: "late_charge_fee", value: "Late Charge Fee" },
		// 		];
		// 	} else if (val == "credits") {
		// 		this.productCategoryLists = [
		// 			{ id: "early_bird_promo", value: "Early Bird Promo" },
		// 			{
		// 				id: "voucher_recommendation_a_friend",
		// 				value: "Voucher Recommendation a Friend",
		// 			},
		// 			{ id: "gift_voucher", value: "Gift Voucher" },
		// 			{ id: "cashback", value: "Cashback" },
		// 			{ id: "refund", value: "Refund" },
		// 			{ id: "installment", value: "Installment" },
		// 			{ id: "payment", value: "Payment" },
		// 			{ id: "overpaying_balance", value: "Overpaying Balance" },
		// 		];
		// 	}
		// },
	},
};
</script>
